import { Field, WrappedFieldProps } from 'redux-form';
import { DurationInput, DurationInputProps, DurationObject } from '@mews-commander/ui';
import { DurationService } from '@mews/framework';

const format = (value: string) => DurationService.toObject(DurationService.parse(value));
const normalize = (durationObject: DurationObject) =>
    DurationService.toString(DurationService.fromObject(durationObject));

const DurationInputRenderer = ({
    /**
     * Redux-form is really dumb, picking up change of values on blur event from child NumberInput component.
     * By leaving out the onBlur event we fix this.
     */
    input: { onBlur, ...input },
    meta,
    ...other
}: DurationInputProps & WrappedFieldProps) => (
    <DurationInput {...input} {...meta} {...other} defaultValue={format(meta.initial)} />
);

export const DurationInputField = (props: DurationInputProps) => (
    <Field name={props.name} props={props} component={DurationInputRenderer} format={format} normalize={normalize} />
);
